import { useMemo } from "react";
import { useFetchAllDebtorUdfCustomFieldsQuery } from "features/userDefinedFields/agencyPortal/debtorUserDefinedFieldsAPI";

/**
 * Custom hook to process debtor search criteria options.
 * Replaces the generic "debtor_custom_field" option with individual text-type custom fields,
 * each prefixed with "dcf_" to enable proper API parameter transformation.
 *
 * @param {Array} debtorSearchCriteria - The search criteria from backend constants
 * @returns {Object} { options: Array, isLoading: boolean }
 */
export function useDebtorSearchCriteriaOptions(debtorSearchCriteria) {
  const { data: debtorCustomFields, isLoading: isDebtorCustomFieldsLoading } =
    useFetchAllDebtorUdfCustomFieldsQuery();

  const options = useMemo(() => {
    if (!debtorSearchCriteria) {
      return [
        {
          label: "...",
          value: "consumer_name",
        },
      ];
    }

    const processedOptions = [];

    debtorSearchCriteria.forEach((criteria) => {
      if (criteria.value === "debtor_custom_field") {
        // Replace with all text-type debtor custom fields
        if (debtorCustomFields) {
          debtorCustomFields.forEach((field) => {
            processedOptions.push({
              label: field.name,
              value: `dcf_${field.slug}`,
            });
          });
        }
      } else {
        // Keep all other criteria as-is
        processedOptions.push({
          label: criteria.display,
          value: criteria.value,
        });
      }
    });

    return processedOptions;
  }, [debtorSearchCriteria, debtorCustomFields]);

  return {
    options,
    isLoading: isDebtorCustomFieldsLoading,
  };
}
